import {Directive, Input, OnChanges, SimpleChanges, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[value-type]',
    standalone: false
})

export class ValueType {

  constructor(private el: ElementRef) { }

  regexStr : any= '^[0-9]*$';

  @Input('value-type') ValueType: string;

  @HostListener('keydown', ['$event']) onKeyDown(event: Event) {

    let e = <KeyboardEvent> event;
    if (this.ValueType) {
      if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode == 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode == 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
          // let it happen, don't do anything
          return;
      }

      let ch = (e.key || String.fromCharCode(e.keyCode));
      if(ch === "Spacebar") ch = " "; // for IE

      switch(this.ValueType){
        case 'numeric': this.regexStr = '^[0-9]*$'; break;
        case 'alpha': this.regexStr = '^[a-zA-Z ]*$'; break;
        case 'alphanospace': this.regexStr = '^[a-zA-Z]*$'; break;
        case 'alphanumeric':  this.regexStr = '^[a-zA-Z0-9]*$'; break;
        case 'alphanumericspacehyphen':  this.regexStr = '^[a-zA-Z0-9 \-]*$'; break;              
        case 'alphanumericspace':  this.regexStr = '^[a-zA-Z0-9 ]*$'; break;      
        case 'alphanumericSpcAposPerComHyp':  this.regexStr = '^[a-zA-Z0-9 \'\.\,\-]*$'; break;
        case 'textPattern' : this.regexStr = /^(?:(?![\!\@\#\$\%\>\^\*\\\(\)\_\+\=\{\}\|\[\]\:\;\<\?\/\~])[\u0000-\u00ff])*$/; break;


        default : this.regexStr = this.ValueType; break;
      }

      let regEx =  new RegExp(this.regexStr);        
      if(regEx.test(ch))
        return;
      else
        e.preventDefault();
    }
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: Event) {

    let e = <KeyboardEvent> event;
    if (this.ValueType) {
      if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode == 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode == 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
          // let it happen, don't do anything
          return;
      }

      let ch = (e.key || String.fromCharCode(e.keyCode));
      if(ch === "Spacebar") ch = " "; // for IE

      switch(this.ValueType){
        case 'numeric': this.regexStr = '^[0-9]*$'; break;
        case 'alpha': this.regexStr = '^[a-zA-Z ]*$'; break;
        case 'alphanospace': this.regexStr = '^[a-zA-Z]*$'; break;
        case 'alphanumeric':  this.regexStr = '^[a-zA-Z0-9]*$'; break;
        case 'alphanumericspace':  this.regexStr = '^[a-zA-Z0-9 ]*$'; break;
        case 'alphanumericspacehyphen':  this.regexStr = '^[a-zA-Z0-9 \-]*$'; break;                
        case 'alphanumericSpcAposPerComHyp':  this.regexStr = '^[a-zA-Z0-9 \'\.\,\-]*$'; break;
        case 'textPattern' : this.regexStr = /^(?:(?![\!\@\#\$\%\>\^\*\\\(\)\_\+\=\{\}\|\[\]\:\;\<\?\/\~])[\u0000-\u00ff])*$/; break;
        default : this.regexStr = this.ValueType; break;
      }

      let regEx =  new RegExp(this.regexStr);   
      if(regEx.test(ch))
        return;
      else
        e.preventDefault();
    }
  }


    @HostListener('paste', ['$event']) paste(e : Event) {
        // Get pasted data via clipboard API
        if (this.ValueType) {

          switch(this.ValueType){
            case 'numeric': this.regexStr = '^[0-9]*$'; break;
            case 'alpha': this.regexStr = '^[a-zA-Z ]*$'; break;
            case 'alphanospace': this.regexStr = '^[a-zA-Z]*$'; break;
            case 'alphanumeric':  this.regexStr = '^[a-zA-Z0-9]*$'; break;
            case 'alphanumericspacehyphen':  this.regexStr = '^[a-zA-Z0-9 \-]*$'; break;                      
            case 'alphanumericspace':  this.regexStr = '^[a-zA-Z0-9 ]*$'; break;      
            case 'alphanumericSpcAposPerComHyp':  this.regexStr = '^[a-zA-Z0-9 \'\.\,\-]*$'; break;
            case 'textPattern' : this.regexStr = /^(?:(?![\!\@\#\$\%\>\^\*\\\(\)\_\+\=\{\}\|\[\]\:\;\<\?\/\~])[\u0000-\u00ff])*$/; break;
            default : this.regexStr = this.ValueType; break;
          }
            let clipboardData = (<any>e).clipboardData || (<any>window).clipboardData;
            let pastedData = clipboardData.getData('Text');
          
          
            let regEx =  new RegExp(this.regexStr);  
            if(regEx.test(pastedData)){
                return;
            }
            else{
                e.preventDefault();
            }
        }
    }

}
